import { HighPriorityAlert } from "./HighPriorityAlert";
export default HighPriorityAlert;
export * from "./HighPriorityAlert";
